module.exports = __webpack_public_path__ + "img/play.b00d61b.svg";